import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Switch,
  useColorModeValue,
} from '@chakra-ui/react';
import { useState } from 'react';
import { useUpdateEventMutation } from '../../../app/api';
import { useEventContext } from '../../../contexts/EventContext';
import { SportEventConfig, SportEvent } from '../../../types/dto';

export interface SportEventconfigurationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SportEventConfigurationModal: React.FC<
  SportEventconfigurationModalProps
> = ({ isOpen, onClose }) => {
  const [updateEvent] = useUpdateEventMutation();
  const { currentEvent } = useEventContext();
  const [changes, setChanges] = useState<SportEventConfig | undefined>();

  const saveSettings = async () => {
    if (changes && currentEvent) {
      await updateEvent({
        id: currentEvent.id,
        config: changes,
        event: currentEvent,
      });
    }
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={saveSettings}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Event Settings</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {currentEvent?.config.flags && (
            <FormControl>
              {Object.entries(currentEvent.config.flags).map((f) => (
                <HStack justify="space-between">
                  <FormLabel htmlFor={f[0]}>{f[0]}</FormLabel>
                  <Switch
                    id={f[0]}
                    isChecked={f[1]}
                    onChange={(e) =>
                      setChanges({
                        ...changes,
                        flags: {
                          ...currentEvent.config.flags,
                          ...changes?.flags,
                          [f[0]]: e.target.checked,
                        },
                      })
                    }
                    x
                  />
                </HStack>
              ))}
            </FormControl>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme={useColorModeValue('orange', 'blue')}
            onClick={saveSettings}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
